import { useEffect } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import routes from '../routes';
import { getData } from './common';

const APP_NAME = 'KartuStok';

const publicRoutes = [
  { path: '/login', exact: true, name: 'Login' },
  { path: '/switch', exact: true, name: 'Switch Login' },
  { path: '/auto', exact: true, name: 'Confirm Account' },
  { path: '/register', exact: true, name: 'Register' },
  { path: '/confirm/resend', exact: true, name: 'Resend Confirmation' },
  { path: '/confirm/:id', exact: true, name: 'Email Confirmation' },
  { path: '/password/reset/request', exact: true, name: 'Request Password Reset' },
  { path: '/password/reset', exact: true, name: 'Reset Password' },
  { path: '/401', exact: true, name: 'Unauthorized' },
  { path: '/404', exact: true, name: 'Not Found' },
  { path: '/500', exact: true, name: 'Server Error' },
  { path: '/transaction/:type/:id/print', name: 'Print Transaction' },
  { path: '/inventory-order/:id/print', name: 'Print Inventory Order' },
  { path: '/report/print/detail', name: 'Print Stock Detail Report' },
  { path: '/report/print/daily-pivot', name: 'Print Daily Stock Pivot Report' },
  { path: '/report/print/summary', name: 'Print Stock Summary Report' },
  { path: '/report/print/minimum/locator', exact: true, name: 'Print Warehouse Minimum Stock Report' },
  { path: '/report/print/minimum', exact: true, name: 'Print Minimum Stock Report' },
];

const titleTranslations = {
  Home: 'Beranda',
  Dashboard: 'Dasbor',
  'Operational Overview': 'Ringkasan Operasional',
  Onboarding: 'Onboarding',
  Login: 'Login',
  Register: 'Daftar',
  'Switch Login': 'Ganti Login',
  'Confirm Account': 'Konfirmasi Akun',
  'Email Confirmation': 'Konfirmasi Email',
  'Resend Confirmation': 'Kirim Ulang Konfirmasi',
  'Request Password Reset': 'Minta Reset Password',
  'Reset Password': 'Reset Password',
  Unauthorized: 'Tidak Diizinkan',
  'Not Found': 'Tidak Ditemukan',
  'Server Error': 'Server Error',
  Users: 'User',
  'Create User': 'Buat User',
  'Update User': 'Ubah User',
  'Roles & Permissions': 'Role & Akses',
  'Create Role': 'Buat Role',
  'Update Role': 'Ubah Role',
  'API Access': 'API Access',
  Settings: 'Pengaturan',
  'Confirm Delete': 'Konfirmasi Hapus',
  'Change Password': 'Ubah Password',
  'Item List': 'Barang',
  'Create Item': 'Buat Barang',
  'Update Item': 'Ubah Barang',
  'Import Items': 'Impor Barang',
  'Import Minimum Stock': 'Impor Stok Minimum',
  'Item Form': 'Form Barang',
  'Item Numbering': 'Penomoran Barang',
  'Item Category List': 'Kategori Barang',
  'Create Item Category': 'Buat Kategori Barang',
  'Update Item Category': 'Ubah Kategori Barang',
  'Import Item Categories': 'Impor Kategori Barang',
  'Unit of Measure List': 'Satuan',
  'Create Unit of Measure': 'Buat Satuan',
  'Update Unit of Measure': 'Ubah Satuan',
  'Import Unit of Measures': 'Impor Satuan',
  'Warehouse List': 'Gudang',
  'Create Warehouse': 'Buat Gudang',
  'Update Warehouse': 'Ubah Gudang',
  'Import Warehouses': 'Impor Gudang',
  'BOM List': 'BOM',
  'Create BOM': 'Buat BOM',
  'Update BOM': 'Ubah BOM',
  'Business Partner List': 'Rekan Bisnis',
  'Create Business Partner': 'Buat Rekan Bisnis',
  'Update Business Partner': 'Ubah Rekan Bisnis',
  'Transaction Category List': 'Kategori Transaksi',
  'Create Transaction Category': 'Buat Kategori Transaksi',
  'Update Transaction Category': 'Ubah Kategori Transaksi',
  'Receipt List': 'Penerimaan Barang',
  'Create Receipt': 'Buat Penerimaan',
  'Update Receipt': 'Ubah Penerimaan',
  'Transaction Receipt Form': 'Form Penerimaan',
  'Issue List': 'Pengeluaran Barang',
  'Create Issue': 'Buat Pengeluaran',
  'Update Issue': 'Ubah Pengeluaran',
  'Transaction Issue Form': 'Form Pengeluaran',
  'Movement List': 'Perpindahan Barang',
  'Create Movement': 'Buat Perpindahan',
  'Update Movement': 'Ubah Perpindahan',
  'Transaction Movement Form': 'Form Perpindahan',
  'Adjustment List': 'Penyesuaian Stok',
  'Create Adjustment': 'Buat Penyesuaian',
  'Update Adjustment': 'Ubah Penyesuaian',
  'Transaction Adjustment Form': 'Form Penyesuaian',
  'Assembly List': 'Assembly',
  'Create Assembly': 'Buat Assembly',
  'Update Assembly': 'Ubah Assembly',
  'Disassembly List': 'Disassembly',
  'Create Disassembly': 'Buat Disassembly',
  'Update Disassembly': 'Ubah Disassembly',
  'Stock Transformation': 'Transformasi Stok',
  'Internal Request List': 'Permintaan Internal',
  'Create Internal Request': 'Buat Permintaan Internal',
  'Supplier Request List': 'Permintaan Supplier',
  'Create Supplier Request': 'Buat Permintaan Supplier',
  'Customer Request List': 'Permintaan Customer',
  'Create Customer Request': 'Buat Permintaan Customer',
  'Inventory Order List': 'Inventory Order',
  'Create Inventory Order': 'Buat Inventory Order',
  'Update Inventory Order': 'Ubah Inventory Order',
  'Print Inventory Order': 'Cetak Inventory Order',
  'Order Fulfillment': 'Realisasi Permintaan',
  'Detail Stock': 'Kartu Stok Detail',
  'Daily Stock Pivot': 'Pivot Stok Harian',
  'Summary Stock': 'Ringkasan Kartu Stok',
  'Minimum Stock': 'Stok Minimum',
  'Warehouse Minimum Stock': 'Stok Minimum Gudang',
  'Print Transaction': 'Cetak Transaksi',
  'Print Stock Detail Report': 'Cetak Kartu Stok Detail',
  'Print Daily Stock Pivot Report': 'Cetak Pivot Stok Harian',
  'Print Stock Summary Report': 'Cetak Ringkasan Kartu Stok',
  'Print Minimum Stock Report': 'Cetak Stok Minimum',
  'Print Warehouse Minimum Stock Report': 'Cetak Stok Minimum Gudang',
  'Email Template List': 'Template Email',
  'Update Email Template': 'Ubah Template Email',
  'Print Template List': 'Template Cetak',
  'Create Print Template': 'Buat Template Cetak',
  'Update Print Template': 'Ubah Template Cetak',
  'Custom Field List': 'Custom Field',
  'Create Custom Field': 'Buat Custom Field',
  'Update Custom Field': 'Ubah Custom Field',
  'Calendar Period': 'Periode Kalender',
};

const allRoutes = [...publicRoutes, ...routes]
  .filter((route) => route.path && route.name)
  .sort((a, b) => b.path.length - a.path.length);

function normalizeRouteName(name) {
  return String(name || '')
    .replace(/^Upeate /, 'Update ')
    .replace(/^Tranasaction /, 'Transaction ');
}

function titleFromPath(pathname) {
  return pathname
    .split('/')
    .filter(Boolean)
    .map((part) => part.replace(/-/g, ' '))
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}

function resolvePageTitle(pathname) {
  const matchedRoute = allRoutes.find((route) => matchPath(pathname, {
    path: route.path,
    exact: route.exact === true,
    strict: false,
  }));
  const normalizedName = normalizeRouteName(matchedRoute?.name || titleFromPath(pathname) || 'Dashboard');
  const language = String(getData('lang') || 'ID').toLowerCase();
  const pageTitle = language === 'id'
    ? (titleTranslations[normalizedName] || normalizedName)
    : normalizedName;

  return `${pageTitle} | ${APP_NAME}`;
}

function formatPageTitle(pageTitle) {
  return `${pageTitle || APP_NAME} | ${APP_NAME}`;
}

function formatDocumentPageTitle(documentNo, pageTitle) {
  return documentNo ? `${documentNo} | ${pageTitle} | ${APP_NAME}` : formatPageTitle(pageTitle);
}

function PageTitleUpdater({ language }) {
  const location = useLocation();

  useEffect(() => {
    document.title = resolvePageTitle(location.pathname);
  }, [location.pathname, language]);

  return null;
}

export { resolvePageTitle };
export { formatPageTitle, formatDocumentPageTitle };
export default PageTitleUpdater;
